export default function navigation(el: HTMLElement) {
  const nav = el.querySelector<HTMLElement>("nav")
  const alertBanner = el.querySelector<HTMLDivElement>(".alert-banner")
  const menuToggle = el.querySelector<HTMLButtonElement>("#main-menu-toggle")
  const mainMenu = el.querySelector<HTMLDivElement>("div#main-menu")
  const subMenuToggles = mainMenu?.querySelectorAll<HTMLButtonElement>(
    "button.sub-menu-toggle[aria-expanded]",
  )
  const mainMenuUnderlay = el.querySelector<HTMLDivElement>(
    "div#main-menu-underlay",
  )

  if (!menuToggle || !mainMenu || !nav) {
    return
  }

  // The menu is open if menu toggle has aria-expanded="true" or
  // if submenu toggles have aria-expanded="true" and it is desktop
  const desktopMql = window.matchMedia("(min-width: 1200px)")

  const handleMenu = () => {
    const isMenuOpen =
      menuToggle.getAttribute("aria-expanded") === "true" ||
      (desktopMql.matches &&
        !!mainMenu.querySelector("button.sub-menu-toggle[aria-expanded=true]"))

    if (isMenuOpen) {
      document.body.classList.add("relative", "overflow-hidden", "h-full")
    } else {
      document.body.classList.remove("relative", "overflow-hidden", "h-full")
    }
  }

  const closeMenu = () => {
    menuToggle.setAttribute("aria-expanded", "false")
    subMenuToggles?.forEach(subMenuToggle => {
      subMenuToggle.setAttribute("aria-expanded", "false")
    })
  }

  const setAlertOffset = () => {
    const mqlOffset = desktopMql.matches ? 1 : 0
    const alertOffset = alertBanner
      ? `${alertBanner.offsetHeight - alertBanner.getBoundingClientRect().bottom + mqlOffset}px`
      : "0px"
    document.body.style.setProperty("--alert-offset", alertOffset)
  }

  const menuToggleMutationObserver = new MutationObserver(mutationList => {
    mutationList.forEach(mutation => {
      mutation.type === "attributes" &&
        mutation.attributeName === "aria-expanded" &&
        menuToggle.setAttribute(
          "aria-label",
          menuToggle.getAttribute("aria-expanded") === "true"
            ? "Close menu"
            : "Open menu",
        )
    })
  })

  const toggleAriaExpanded = (toggle: HTMLButtonElement) => {
    toggle.setAttribute(
      "aria-expanded",
      toggle.getAttribute("aria-expanded") === "true" ? "false" : "true",
    )
  }

  const setHeights = () => {
    const navHeight = `${nav.offsetHeight}px`
    const alertHeight = alertBanner ? `${alertBanner.offsetHeight}px` : "0px"
    document.body.style.setProperty("--nav-height", navHeight)
    document.body.style.setProperty("--alert-height", alertHeight)
  }

  const mastheadResizeObserver = new ResizeObserver(() => {
    setHeights()
  })

  // Event listeners and observers
  mastheadResizeObserver.observe(el)
  menuToggleMutationObserver.observe(menuToggle, { attributes: true })

  subMenuToggles?.forEach(subMenuToggle => {
    subMenuToggle.addEventListener("click", () => {
      subMenuToggles.forEach(toggle => {
        toggle !== subMenuToggle &&
          toggle.setAttribute("aria-expanded", "false")
      })
      toggleAriaExpanded(subMenuToggle)
      setAlertOffset()
      handleMenu()
    })
  })

  menuToggle.addEventListener("click", () => {
    toggleAriaExpanded(menuToggle)
    setAlertOffset()

    if (menuToggle.getAttribute("aria-expanded") === "false") {
      subMenuToggles?.forEach(subMenuToggle => {
        subMenuToggle.setAttribute("aria-expanded", "false")
      })
    }

    handleMenu()
  })

  mainMenu.addEventListener("click", e => {
    e.stopPropagation()
  })

  mainMenuUnderlay?.addEventListener("click", () => {
    closeMenu()
    handleMenu()
  })

  document.addEventListener("keydown", e => {
    if (e.key === "Escape") {
      closeMenu()
      handleMenu()
    }
  })

  desktopMql.addEventListener("change", e => {
    closeMenu()
    handleMenu()
  })

  // Add shadow to nav on scroll
  // let scrollpos = window.scrollY
  // const header = document.querySelector("nav")
  // const header_height = header ? header.offsetHeight : 0
  // const add_class_on_scroll = () =>
  //   header?.classList.add("shadow-2", "bg-white")
  // const remove_class_on_scroll = () =>
  //   header?.classList.remove("shadow-2", "bg-white")
  // window.addEventListener("scroll", function () {
  //   scrollpos = window.scrollY
  //   if (scrollpos >= header_height) {
  //     add_class_on_scroll()
  //   } else {
  //     remove_class_on_scroll()
  //   }
  // })

  // Main
  setHeights()
}
